import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { PainSection } from './components/PainSection';
import { Sistema24K } from './components/Sistema24K';
import { MainOffer } from './components/MainOffer';
import { PricingPlans } from './components/PricingPlans';
import { Testimonials } from './components/Testimonials';
import { LogoCarousel } from './components/LogoCarousel';
import { AboutUs } from './components/AboutUs';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
export function App() {
  return <div className="min-h-screen bg-brand-bg text-brand-text font-sans selection:bg-brand-cyan selection:text-brand-darker" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <Header data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <SocialProof data-id="element-5" />
        <PainSection data-id="element-6" />
        <Sistema24K data-id="element-7" />
        <MainOffer data-id="element-8" />
        <PricingPlans data-id="element-9" />
        <Testimonials data-id="element-10" />
        <LogoCarousel data-id="element-11" />
        <AboutUs data-id="element-12" />
        <Guarantee data-id="element-13" />
        <FAQ data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>

      <Footer data-id="element-16" />
      <FloatingWhatsApp data-id="element-17" />
    </div>;
}